export enum StatusReturn {
  ERROR = 'ERROR',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}

export interface Return<T> {
  status: StatusReturn;
  response: T;
}
